module.exports = "/images/arrowBack.svg";